<nz-page-header nzTitle="Member List"></nz-page-header>

<a [routerLink]="['/member/new']" nz-button nzType="dashed" class="mb-1" >+ Onboard New Member</a>
<nz-table nzSize="small" [nzData]="[1]" [nzFrontPagination]="false">
	<thead>
		<tr>
			<th>Name</th>
			<th>Surname</th>
			<th>Date Of Birth</th>
			<th>ID Number</th>
		</tr>
	</thead>
	<tbody>
		<tr *ngFor="let item of data" (dblclick)="doView(item)">
			<td>{{item.name}}</td>
			<td>{{item.surname}}</td>
			<td>{{item.dateOfBirth}}</td>
			<td>{{item.idNumber}}</td>
		</tr>
	</tbody>
</nz-table>
